import * as Sentry from '@sentry/nextjs'

export const withSilentFailure = (fn: () => void, { onError }: { onError?: (err: Error) => void } = {}) => {
  try {
    fn()
  } catch (err) {
    Sentry.captureException(err)
    if (onError) {
      onError(err as Error)
    }
  }
}
